import { Box } from "@mui/material";
import styled from "styled-components";

export const AppointmentCardStyled = styled(Box)`
  background: var(--pure-white-color);
  padding: 20px;
  box-shadow: 0px 0px 4px 0px #f0f0f066;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  .top-part {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .name-and-time {
      display: flex;
      flex-direction: column;
      gap: 4px;
      .name {
        font-weight: 500;
        font-size: 18px;
        color: var(--coal-black-color);
      }
      .time {
        font-weight: 400;
        font-size: 16px;
        color: var(--muted-gray-color);
      }
    }
    .date {
      font-weight: 500;
      font-size: 12px;
      color: var(--royal-blue-color);
      background: var(--light-blue-color);
      height: 38px;
      border-radius: 88px;
      min-width: 82px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }
  }
  .bottom-part {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .label {
      font-weight: 500;
      font-size: 14px;
      color: var(--muted-gray-color);
    }
    .value {
      font-weight: 400;
      font-size: 16px;
      color: var(--charcoal-black-color);
      word-break: break-all;
    }
  }
`;
